"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ScatterPlotDescriptor = void 0;
var tslib_1 = require("tslib");
var PluggableScatterPlot_1 = require("./PluggableScatterPlot");
var BigChartDescriptor_1 = require("../BigChartDescriptor");
var ScatterPlotDescriptor = /** @class */ (function (_super) {
    tslib_1.__extends(ScatterPlotDescriptor, _super);
    function ScatterPlotDescriptor() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ScatterPlotDescriptor.prototype.getFactory = function () {
        return function (params) { return new PluggableScatterPlot_1.PluggableScatterPlot(params); };
    };
    return ScatterPlotDescriptor;
}(BigChartDescriptor_1.BigChartDescriptor));
exports.ScatterPlotDescriptor = ScatterPlotDescriptor;
//# sourceMappingURL=ScatterPlotDescriptor.js.map